import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import classNames from 'classnames/bind';
import ReCAPTCHA from 'react-google-recaptcha';

import styles from './form.module.scss';
import { onEmailCheck, onlyNumberKeyPress } from '../../../../utils/regular';

const cx = classNames.bind(styles);

function General({ agree }) {
  const navigate = useNavigate();
  const fileNameRef = useRef();
  const recaptchaRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    emailId: '',
    emailDetail: '',
    address: '',
    addressDetail: '',
    product: '',
    store: '',
    content: '',
    mobile1: '',
    mobile2: '',
    mobile3: '',
    file: null,
    password: '',
  });

  const onClick = () => {
    const { name, emailId, emailDetail, product, store, content, mobile1, mobile2, mobile3, address, addressDetail, password } = formData;

    if (!agree) {
      alert('개인정보 처리방침에 동의해 주세요.');
      return;
    }

    if (name === '') {
      alert('이름을 작성해 주세요.');
      return;
    }

    if (emailId === '' || emailDetail === '') {
      alert('이메일을 작성해 주세요.');
      return;
    }

    if (onEmailCheck(emailDetail)) {
      return;
    }

    if (mobile1 === '' || mobile2 === '' || mobile3 === '') {
      alert('휴대전화를 작성해 주세요.');
      return;
    }

    if (product === '') {
      alert('주문제품을 선택해 주세요.');
      return;
    }

    if (store === '') {
      alert('구매처를 작성해 주세요.');
      return;
    }

    if (address === '') {
      alert('주소를 작성해 주세요.');
      return;
    }

    if (addressDetail === '') {
      alert('상세주소를 작성해 주세요.');
      return;
    }

    if (content === '') {
      alert('내용을 작성해 주세요.');
      return;
    }

    if (password === '') {
      alert('비밀번호를 작성해 주세요.');
      return;
    }

    const recaptchaResponse = recaptchaRef.current.getValue();
    if (recaptchaResponse === '') {
      alert('로봇이 아님을 확인해 주세요.');
      return;
    }

    postAxios();
  };

  const postAxios = () => {
    const data = new FormData();
    data.append('name', formData.name);
    data.append('email', `${formData.emailId}@${formData.emailDetail}`);
    data.append('mobile', formData.mobile1 + formData.mobile2 + formData.mobile3);
    data.append('address', formData.address);
    data.append('addressDetail', formData.addressDetail);
    data.append('product', formData.product);
    data.append('store', formData.store);
    data.append('content', formData.content);
    data.append('password', formData.password);
    if (formData.file !== null) {
      data.append('file', formData.file);
    }
    data.append('recaptcha', recaptchaRef.current.getValue());

    axios
      .post('https://pulmuone.console.flyground.co.kr/api/qna/general', data, {
        headers: {
          Accept: 'application/json',
          'Content-type': 'Application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then(() => {
        alert('제품, 배송, 기타 문의가 접수되었습니다.');
        navigate('/');
      })
      .catch((err) => console.error(err));
  };

  const onChange = (event) => {
    const { value, name } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onChangeFile = (event) => {
    const { files } = event.target;

    fileNameRef.current.innerText = files[0].name;

    setFormData((prev) => ({
      ...prev,
      file: files[0],
    }));
  };

  const findAddress = () => {
    new window.daum.Postcode({
      oncomplete: (data) => {
        setFormData({
          ...formData,
          address: data.address,
        });
      },
    }).open();
  };

  return (
    <div className={cx('container')}>
      <div className={cx('form')}>
        <div className={cx('inner')}>
          <ul className={cx('left')}>
            <li>
              <h4 className={cx(['title', 'required'])}>이름</h4>
              <div className={cx('box')}>
                <input name="name" onChange={onChange} className={cx('text')} type="text" placeholder="이름을 작성해 주세요." />
              </div>
            </li>
            <li>
              <h4 className={cx(['title', 'required'])}>이메일</h4>
              <div className={cx('box')}>
                <input name="emailId" onChange={onChange} className={cx('text')} type="text" placeholder="이메일을 작성해 주세요." />
                <p className={cx('connect')}>@</p>
                <input name="emailDetail" onChange={onChange} className={cx('text')} type="text" placeholder="직접 입력" />
              </div>
            </li>
            <li>
              <h4 className={cx(['title', 'required'])}>휴대전화</h4>
              <div className={cx(['box', 'background'])}>
                <input
                  name="mobile1"
                  onChange={onChange}
                  className={cx(['text', 'center'])}
                  type="text"
                  placeholder="010"
                  maxLength={3}
                  onKeyPress={onlyNumberKeyPress}
                />
                <p className={cx('connect')}>-</p>
                <input
                  name="mobile2"
                  onChange={onChange}
                  className={cx(['text', 'center'])}
                  type="text"
                  placeholder="0000"
                  maxLength={4}
                  onKeyPress={onlyNumberKeyPress}
                />
                <p className={cx('connect')}>-</p>
                <input
                  name="mobile3"
                  onChange={onChange}
                  className={cx(['text', 'center'])}
                  type="text"
                  placeholder="0000"
                  maxLength={4}
                  onKeyPress={onlyNumberKeyPress}
                />
              </div>
            </li>
            <li>
              <h4 className={cx(['title', 'required'])}>주문제품</h4>
              <div className={cx('box')}>
                <select name="product" onChange={onChange}>
                  <option value={''}>제품을 선택해 주세요.</option>
                  <option value={'풀무원샘물'}>풀무원샘물</option>
                  <option value={'풀무원샘물 15L'}>풀무원샘물 15L</option>
                  <option value={'맛있는샘물 18.9L'}>맛있는샘물 18.9L</option>
                  <option value={'냉온수기'}>냉온수기</option>
                </select>
              </div>
            </li>
            <li>
              <h4 className={cx(['title', 'required'])}>구매처</h4>
              <div className={cx('box')}>
                <input name="store" onChange={onChange} className={cx('text')} type="text" placeholder="구매처를 입력해 주세요." />
              </div>
            </li>
            <li>
              <h4 className={cx('title')}>첨부파일</h4>
              <div className={cx('box')}>
                <input name="file" onChange={onChangeFile} id="general_file" className={cx('file')} type="file" />
                <p ref={fileNameRef} className={cx('fileName')}>
                  파일을 선택해 주세요.
                </p>
                <label className={cx('btn')} htmlFor="general_file">
                  파일 첨부
                </label>
              </div>
            </li>
          </ul>
          <ul className={cx('right')}>
            <li>
              <h4 className={cx(['title', 'required'])}>주소</h4>
              <div className={cx('box')}>
                <input
                  name="address"
                  value={formData.address}
                  readOnly
                  className={cx('text')}
                  type="text"
                  placeholder="주소를 검색해 주세요."
                />
                <button className={cx('btn')} onClick={findAddress}>
                  주소 검색
                </button>
              </div>
              <div className={cx('box')}>
                <input
                  name="addressDetail"
                  onChange={onChange}
                  className={cx('text')}
                  type="text"
                  placeholder="상세주소를 입력해 주세요."
                />
              </div>
            </li>
            <li>
              <h4 className={cx(['title', 'required'])}>상세내용</h4>
              <div className={cx('box')}>
                <textarea name="content" onChange={onChange}></textarea>
              </div>
            </li>
            <li>
              <h4 className={cx(['title', 'required'])}>비밀번호</h4>
              <div className={cx('box')}>
                <input
                  name="password"
                  maxLength={12}
                  onChange={onChange}
                  className={cx('text')}
                  type="password"
                  placeholder="비밀번호를 입력해 주세요."
                />
              </div>
            </li>
            <li>
              <ReCAPTCHA ref={recaptchaRef} sitekey="6Le_5voqAAAAAMXmdAej38QsSDL9K-cM4OjoT3Ec" />
            </li>
          </ul>
        </div>
        <input onClick={onClick} type={'submit'} value={'접수하기'} className={cx('btn')} />
      </div>
    </div>
  );
}

export default General;
